import { render, staticRenderFns } from "./OpExamine.vue?vue&type=template&id=82fb7d9a&scoped=true"
import script from "./OpExamine.vue?vue&type=script&lang=js"
export * from "./OpExamine.vue?vue&type=script&lang=js"
import style0 from "./OpExamine.vue?vue&type=style&index=0&id=82fb7d9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fb7d9a",
  null
  
)

export default component.exports